import { useMemo } from "react";
import { matchesFilters, sortRows, toLogRow } from "@/lib/leadLog";

export function useLeadLog(leads, repsById, today, filters, sort) {
  const rows = useMemo(() => leads.map((l) => toLogRow(l, repsById, today)), [leads, repsById, today]);
  const sources = useMemo(() => [...new Set(leads.map((l) => l.source).filter(Boolean))].sort(), [leads]);
  const visible = useMemo(() => sortRows(rows.filter((r) => matchesFilters(r, filters)), sort), [rows, filters, sort]);
  return { rows, sources, visible };
}
